import {
   ADD_VEHICLE, UPDATE_VEHICLE, FETCH_VEHICLE_DETAIL,
} from 'src/api/routes';
import { GET, POST } from 'src/network/apiHandler';
import config from 'src/globals';

const { API_BASE_URL } = config;

export const addVehicle = async (body) => {
    return POST(`${API_BASE_URL}${ADD_VEHICLE}`, body);
};

export const updateVehicle = async (id, body) => {
    return POST(`${API_BASE_URL}${UPDATE_VEHICLE}${id}`, body);
};

export const fetchVehicleInfo = async (id) => {
    return GET(`${API_BASE_URL}${FETCH_VEHICLE_DETAIL}${id}`);
};
